import { Trans } from "@lingui/react/macro";

export function UnassignedItem() {
    return (
        <i>
            <Trans>Unassigned</Trans>
        </i>
    );
}
